export default __webpack_public_path__ + "static/media/icon_copy_line.c147e0e9.svg";